"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validResponseContentTypes = void 0;
var validResponseContentTypes = ["application/json", "application/geo+json", "image/jpeg"];
exports.validResponseContentTypes = validResponseContentTypes;